import React from 'react';
import PropTypes from 'prop-types';

const FormHandlersWrapper = ({ children, className }) => (
  <div className={`flex gap-3 justify-end ${className}`}>
    {children}
  </div>
);

FormHandlersWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

FormHandlersWrapper.defaultProps = {
  className: '',
}

export default FormHandlersWrapper;
